function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M3.6,43.8H12v-2H3.6c-0.6,0-1.1-0.5-1.1-1.1V7.4c0-0.6,0.5-1.1,1.1-1.1h25.9v-2H3.6c-1.7,0-3.1,1.4-3.1,3.1v33.3   C0.5,42.4,1.9,43.8,3.6,43.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.4,4.2H31.5v2h12.9c0.6,0,1.1,0.5,1.1,1.1v33.3c0,0.6-0.5,1.1-1.1,1.1H14v2h30.4c1.7,0,3.1-1.4,3.1-3.1V7.4   C47.5,5.6,46.1,4.2,44.4,4.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.5,26.3V12.1c0-1.3-1.1-2.4-2.4-2.4H9.9c-1.3,0-2.4,1.1-2.4,2.4l0,18c0,0.4,0.2,0.8,0.6,0.9c0.1,0,0.2,0.1,0.4,0.1   c0.3,0,0.5-0.1,0.7-0.3l10.4-10.9l6.2,6.5c0.2,0.2,0.4,0.3,0.7,0.3c0,0,0,0,0,0c0.3,0,0.5-0.1,0.7-0.3l3.4-3.6l6.3,6.2l-24.4,0v2   l26.8,0c0.4,0,0.8-0.2,0.9-0.6s0.1-0.8-0.2-1.1l-8.8-8.7c-0.2-0.2-0.5-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3l-3.4,3.5l-6.2-6.5   c-0.2-0.2-0.5-0.3-0.7-0.3h0c-0.3,0-0.5,0.1-0.7,0.3l-9.4,9.8l0-15.5c0-0.2,0.2-0.4,0.4-0.4h28.1c0.2,0,0.4,0.2,0.4,0.4v14.3H40.5z   "
}), /*#__PURE__*/React.createElement("rect", {
  height: 2,
  width: 19.9,
  x: 14,
  y: 36.4
}), /*#__PURE__*/React.createElement("rect", {
  height: 2,
  width: 10.7,
  x: 18.7,
  y: 32.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.7,17.9c-0.7,0-1.3-0.6-1.3-1.3h-2c0,1.8,1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3c-0.6,0-1.1,0.2-1.6,0.4   l1,1.7c0.2-0.1,0.4-0.2,0.6-0.2c0.7,0,1.3,0.6,1.3,1.3S27.4,17.9,26.7,17.9z"
}));

function SvgCardBackgroundImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBackgroundImage);
export default __webpack_public_path__ + "static/media/card_background_image.ac4943aa.svg";
export { ForwardRef as ReactComponent };